import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectDocumentStatus = createSelector(
  [(store: RootState) => store.documentSupervisorShow.document.status],
  (status) => status
);
